import { Action } from 'redux';

export interface State {
  isActive: boolean;
  currentStepIndex: number;
}

export enum ActionType {
  startGuidedMode = 'guidedMode/startGuidedMode',
  goToGuidedStep = 'guidedMode/goToGuidedStep',
  nextGuidedStep = 'guidedMode/nextGuidedStep',
  previousGuidedStep = 'guidedMode/previousGuidedStep',
  finishGuidedMode = 'guidedMode/finishGuidedMode',
  cancelGuidedMode = 'guidedMode/cancelGuidedMode',
}

export type StartGuidedModeAction = Action<ActionType.startGuidedMode>;

export type GoToGuidedStepAction = Action<ActionType.goToGuidedStep> & {
  stepIndex: number;
};

export type NextGuidedStepAction = Action<ActionType.nextGuidedStep>;

export type PreviousGuidedStepAction = Action<ActionType.previousGuidedStep>;

export type FinishGuidedModeAction = Action<ActionType.finishGuidedMode>;

export type CancelGuidedModeAction = Action<ActionType.cancelGuidedMode>;

export type Actions =
  | StartGuidedModeAction
  | GoToGuidedStepAction
  | NextGuidedStepAction
  | PreviousGuidedStepAction
  | FinishGuidedModeAction
  | CancelGuidedModeAction;
